module.exports = __webpack_public_path__ + "static/media/39.3d7e4310.jpg";